import type { User } from 'firebase/auth'
import { useAuth } from './useAuth'
import { useUserProfilesWithLoading } from './useUserProfiles'
import type { UserProfile } from '../types'

// The current user's own profile for nav/header chrome: the Firestore copy when
// available, otherwise an auth-state fallback. `profile` is undefined for guests
// (unauthenticated or anonymous), so callers can branch on `isUser`.
// `profileLoading` is true until the Firestore copy settles: the auth fallback
// can lack a photo the profile has, so avatars wait rather than flash initials.
export function useSelfProfile(): {
  user: User | null
  isUser: boolean
  profile: UserProfile | undefined
  profileLoading: boolean
} {
  const { user, signedInUid } = useAuth()
  const isUser = !!signedInUid
  const { profiles, loading } = useUserProfilesWithLoading(isUser ? [user!.uid] : [])
  const stored = isUser ? profiles[user!.uid] : undefined
  const profile = isUser
    ? stored ?? {
        uid: user!.uid,
        displayName: user!.displayName ?? '',
        photoURL: user!.photoURL,
      }
    : undefined
  return { user, isUser, profile, profileLoading: isUser && loading && !stored }
}
